import { Dialog, Transition } from '@headlessui/react';
import { KeyboardShortcut } from 'components/shared/InteractionManagement/KeyboardShortcut';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { SearchBarDialog } from './SearchBarDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { useHistory } from 'react-router-dom';

export const SearchBarContainer: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const history = useHistory();
  useEffect(() => {
    const temp = history.listen(() => {
      setIsOpen(false);
    });
    return temp;
  }, [history, setIsOpen]);

  const buttonRef = useRef<HTMLButtonElement>(null);

  const onAction = () => {
    buttonRef.current?.click();
  };
  return (
    <div className={'w-80'}>
      <button
        type="button"
        ref={buttonRef}
        className={
          'rounded-xl bg-white px-3 py-1.5 text-sm font-normal text-foundation-primary shadow-sm ring-1 ring-inset ring-foundation-primary hover:bg-extra-grey-light focus:ring-foundation-primary disabled:bg-zinc-100 disabled:text-zinc-500 disabled:ring-0'
        }
        onClick={() => setIsOpen(true)}
        data-test-id={'Jump-Button'}
      >
        <FontAwesomeIcon icon={faMagnifyingGlass} size={'xs'} /> Search orders by file number...
      </button>
      <Transition as={Fragment} appear show={isOpen}>
        <Dialog as="div" className="relative z-20" onClose={() => setIsOpen(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/10" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="items-top mt-16 flex justify-center p-4 text-center">
              <SearchBarDialog />
            </div>
          </div>
        </Dialog>
      </Transition>
      <KeyboardShortcut triggerKey={'k'} onAction={onAction} />
    </div>
  );
};
